export const provinRouters = [
  //省级门户
  {
    path: "/:province/home",
    name: "proHome",
    component: () => import("../views/CustomizedHome/Home.vue"),
    meta: {
      title: "省级专业群首页"
    },
    children: [
      {
        path: "portal",
        name: "proPortal",
        component: () =>
          import("../views/CustomizedHome/childrens/CustomizedHome.vue"),
      },
      {
        path: "projectGroups",
        name: "porSubProjectPortal",
        component: () =>
          import("../views/CustomizedHome/childrens/CustomizedProjectGroup.vue"),
      },
      {
        path: "material",
        name: "proMaterialPortal",
        component: () =>
          import("../views/CustomizedHome/childrens/CustomizedMaterial.vue"),
      },
      {
        path: "course",
        name: "proCoursePortal",
        component: () =>
          import("../views/CustomizedHome/childrens/CustomizedCourse.vue"),
      },
      {
        path: "notice/:noticeId",
        name: "proNotice",
        component: () =>
          import("../views/CustomizedHome/childrens/CustomizedNotice.vue"),
      },
      {
        path: "/:province/material/:materialId",
        name: "proMaterial",
        props: true,
        component: () => import("../views/MaterialDetail/materialPreview.vue"),
        meta: {
          title: "素材预览"
        },
      },
      {
        path: "/:province/course/:courseOpenId",
        name: "proCourse",
        props: true,
        component: () => import("../views/CourseDetail/index.vue"),
        meta: {
          title: "课程详情"
        }
      }
    ]
  }
];
